import { render, staticRenderFns } from "./LocacaoRelatorios.vue?vue&type=template&id=5ae67809&"
import script from "./LocacaoRelatorios.vue?vue&type=script&lang=js&"
export * from "./LocacaoRelatorios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports